import { PLAN_SIZE, getPlanSizeName } from 'ck-core/source/data/PlanSize';
import { PLAN_DURATION } from 'ck-core/source/data/PlanDuration';
import { PRODUCTS, PRODUCT_ID } from 'ck-core/source/data/Product';
import { planDurationLang } from 'ck-core/source/data/planLang';
export interface PlanType {
	product: PRODUCT_ID;
	duration: PLAN_DURATION;
	size: PLAN_SIZE;
}

export const getPlanDescription = (planType: PlanType) => {
	const productName = PRODUCTS[planType.product].name;
	const sizeName = getPlanSizeName(planType.size);
	const durationName = planDurationLang[planType.duration];
	return `${productName} - ${sizeName} - ${durationName}`;
};

export const getPlanIdForPlanType = (planType: PlanType): string => {
	return `ck-v4-${planType.product}-${planType.duration}${
		planType.size === PLAN_SIZE.FAMILY ? '-family' : ''
	}`;
};
